import { twJoin, twMerge } from 'tailwind-merge';

import { useTheme } from '@/_shared';

import type { BadgeProps } from './types';

export function useBadge(props: BadgeProps) {
  const { className, as = 'base', size = 'base', type = 'neutral', ...other } = props;

  const { badge } = useTheme();

  const cls = twMerge(twJoin(badge.base, badge.size[size], badge.as[as][type]), className);

  return { cls, ...other };
}
